'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBaseUrl = exports.changeUrl = exports.parseRoute = exports.parseRouteOptions = exports.parseRouteKeys = exports.pushState = exports.compileHash = exports.compileOptions = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
}; // DANGER: Needs rewrite!


var _pathToRegexp = require('path-to-regexp');

var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var compileOptions = exports.compileOptions = function compileOptions(options) {
  return Object.keys(options).map(function (key) {
    return key + '=' + options[key];
  }).join('&');
};

var compileHash = exports.compileHash = function compileHash(route) {
  var path = route.path,
      keys = route.keys,
      options = route.options;
  var toPath = (0, _pathToRegexp.compile)(path);
  var query = compileOptions(options);
  return '#/' + toPath(keys) + (query === '' ? '' : '?' + query);
};

var pushState = exports.pushState = function pushState(route) {
  var hash = compileHash(route);

  if (location.hash !== hash) {
    history.pushState({
      route: route
    }, '', hash);
  }
};

var parseRouteKeys = exports.parseRouteKeys = function parseRouteKeys(pathString, result) {
  var keys = result.keys,
      regexp = result.regexp;
  var regexpResult = regexp.exec(pathString);
  return keys.reduce(function (obj, key, i) {
    return _extends({}, obj, _defineProperty({}, key.name, i + 1 < regexpResult.length ? regexpResult[i + 1] : ''));
  }, {});
};

var parseRouteOptions = exports.parseRouteOptions = function parseRouteOptions(optionsString) {
  return optionsString.split('&').map(function (str) {
    return str.split('=');
  }).filter(function (keyValuePair) {
    return keyValuePair.length === 2;
  }).reduce(function (obj, keyValuePair) {
    return _extends({}, obj, _defineProperty({}, keyValuePair[0], keyValuePair[1]));
  }, {});
};

var parseRoute = exports.parseRoute = function parseRoute(hash, paths) {
  var hashParts = hash.split('?');
  var pathString = hashParts[0];
  var optionsString = hashParts.length > 1 ? hashParts[1] : '';
  var result = paths.map(function (path) {
    var keys = [];
    var regexp = (0, _pathToRegexp2.default)(path, keys);
    return {
      path: path,
      regexp: regexp,
      keys: keys
    };
  }).find(function (path) {
    return path.regexp.test(pathString);
  });
  var path = result ? result.path : pathString;
  var keys = result ? parseRouteKeys(pathString, result) : {};
  var options = parseRouteOptions(optionsString);
  return {
    path: path,
    keys: keys,
    options: options
  };
};

var changeUrl = exports.changeUrl = function changeUrl(route) {
  return window.location.href = '' + route;
};

var getBaseUrl = exports.getBaseUrl = function getBaseUrl() {
  return window.location.protocol + '//' + window.location.host + (window.location.pathname === '/' ? '' : window.location.pathname);
};